"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const react_tiny_virtual_list_dmk_1 = __importDefault(require("react-tiny-virtual-list-dmk"));
const luxon_1 = require("luxon");
const Add_1 = __importDefault(require("@mui/icons-material/Add"));
const Done_1 = __importDefault(require("@mui/icons-material/Done"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const transactions_1 = require("companion-app-components/flux/transactions");
const Dump_1 = __importDefault(require("components/Dump"));
const QButton_1 = __importDefault(require("components/QButton"));
const ZeroStateView_1 = __importDefault(require("components/ZeroStateView"));
const CategoryField_1 = __importDefault(require("components/QuickenControls/CategoryField"));
const AmountField_1 = __importStar(require("components/QuickenControls/AmountField"));
const utils_1 = require("utils/date/utils");
const utils_2 = require("data/transactions/utils");
const safebox_svg_1 = __importDefault(require("assets/zero-state-images/safebox.svg"));
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const TransactionSelectList = ({ selectorProps = {}, clickFunc, highlight, hideCategory, multiSelect, onReset, filterByType, transactionListSelector, filter, }) => {
    const displayNodes = (0, react_1.useRef)([]);
    const { classes } = useStyles();
    const acctTxns = (0, react_redux_1.useSelector)((state) => transactionListSelector(state, Object.assign(Object.assign({}, selectorProps), { filter })));
    const checkHighlight = (id) => {
        if (multiSelect) {
            return (highlight === null || highlight === void 0 ? void 0 : highlight.contains(id)) || false;
        }
        return highlight === id;
    };
    const getAcctTxns = () => filterByType ? acctTxns.filter(filterByType) : acctTxns;
    const generateTxns = () => {
        let acctTxns2 = getAcctTxns();
        acctTxns2 = acctTxns2 && acctTxns2.filter((txn) => !(0, utils_2.isBankPending)(txn) && !(0, utils_2.isC2RTransaction)(txn));
        displayNodes.current = [];
        let i = 0;
        acctTxns2.map((txn) => {
            const isSplit = transactions_1.transactionsUtils.isSplitTxn(txn);
            if (txn.payee) {
                displayNodes.current.push(<div role="presentation" key={i} id={JSON.stringify(txn)} onClick={clickFunc} className={checkHighlight(txn.id) ? classes.txnLineShaded : classes.txnLine}>
            <Dump_1.default obj={txn}/>
            <Typography_1.default variant="body2" noWrap className={classes.dater}>
              {luxon_1.DateTime.fromISO(txn.postedOn).toFormat(`MMM d'${(0, utils_1.getOrdinalSuffix)(txn.postedOn)}', yyyy`)}
            </Typography_1.default>
            <Typography_1.default variant="body2" noWrap className={classes.payer}>
              {txn.payee}
            </Typography_1.default>
            {!hideCategory && (isSplit &&
                        <Typography_1.default variant="body2" noWrap className={classes.payer}>
                {'---Split---'}
              </Typography_1.default>)}
            {!hideCategory && (!isSplit && <CategoryField_1.default variant="body2" classNameWhenNotEditable={classes.typer} disableTooltip value={txn.coa} longCats={false} autoFocus={false} noWrap/>)}
            <AmountField_1.default showSign={AmountField_1.ShowSignEnum.POSITIVE_ONLY} showColor={AmountField_1.ShowColorEnum.POSITIVE_ONLY} color={txn.amount > 0 ? 'green' : undefined} value={txn.amount} variant="body2" className={classes.amter} noWrap/>
            <div className={classes.checkWrap}>
              {checkHighlight(txn.id) && <Done_1.default className={classes.checkIcon}/>}
              {!checkHighlight(txn.id) && <Add_1.default className={classes.selectIcon}/>}
            </div>
          </div>);
                i += 1;
                return '';
            }
            return '';
        });
    };
    const acctTxns2 = getAcctTxns();
    if (!(acctTxns2 === null || acctTxns2 === void 0 ? void 0 : acctTxns2.size)) {
        return (<div className={classes.stateView}>
        <ZeroStateView_1.default icon={safebox_svg_1.default} primary="We couldn't find any transactions" secondary={<>
              You might have searched for something too specific.
              <br />
              Try resetting the search if so
            </>} classes={{ secondary: classes.zeroState, root: classes.zeroRoot }}/>
        <div className={classes.zeroReset}>
          <QButton_1.default onClick={onReset} variant="text">
            Click Here
          </QButton_1.default>
          <Typography_1.default style={{ color: '#666', lineHeight: '32px' }}>
            to reset the search.
          </Typography_1.default>
        </div>
      </div>);
    }
    if (acctTxns2 && displayNodes.current) {
        generateTxns();
    }
    return (acctTxns2.size &&
        (<react_tiny_virtual_list_dmk_1.default 
        // @ts-expect-error: Property 'id' does not exist on type 'IntrinsicAttributes
        id={'transaction-choice-list'} height={360} itemCount={displayNodes.current.length} overscanCount={30} itemSize={60} renderItem={({ style, index }) => (displayNodes.current[index] ?
                <div style={style} key={index}>
            {displayNodes.current[index]}
          </div>
                : '')} className={classes.VL}/>));
};
exports.default = TransactionSelectList;
